import { isAfter, isSameDay, isWithinInterval, Locale } from 'date-fns';
import { zonedTimeToUtc, formatInTimeZone } from 'date-fns-tz';

import { FlexipassSettings, ReservationWithRateDetailsDTO } from '@/models';

export const getDigitalKeysAvailability = (
  timezone: string,
  flexipassSettings: FlexipassSettings,
  reservation: ReservationWithRateDetailsDTO,
  locale?: Locale,
  now: Date = new Date(),
) => {
  const { default_checkin_time, default_checkout_time } = flexipassSettings;

  const arrivalDateStr = reservation.startDate;
  const departureDateStr = reservation.endDate;

  const zonedCheckInDatetime = `${arrivalDateStr}T${default_checkin_time}`;
  const zonedCheckOutDatetime = `${departureDateStr}T${default_checkout_time}`;

  const utcCheckInDate = zonedTimeToUtc(zonedCheckInDatetime, timezone);
  const utcCheckOutDate = zonedTimeToUtc(zonedCheckOutDatetime, timezone);

  let isAvailable = false;
  try {
    isAvailable = isWithinInterval(now, {
      start: utcCheckInDate,
      end: utcCheckOutDate,
    });
  } catch (err) {}

  return {
    isAvailable,
    isPastCheckout: isAfter(now, utcCheckOutDate),
    arrivingToday: isSameDay(utcCheckInDate, now),
    formattedCheckInHours: formatInTimeZone(
      utcCheckInDate,
      timezone,
      'HH:mm a',
      { locale },
    ),
  };
};
